/**
 * @module SiteMenu
 * @description Site Menu
 */
import { useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/legacy/image';
import PropTypes from 'prop-types';
import SiteNavigation from '@/js/plugins/site-navigation';
import { stringify } from '@/js/utils/filters';
import { fastly } from '@/js/utils/helpers';
import { trackEvent } from '@/js/helpers/tracking';

const defaultLinks = [
  {
    title: 'Bundles',
    href: '/ps/plans-pricing/',
    links: []
  },
  {
    title: 'Internet',
    href: 'https://frontier.com/shop/internet/fiber-internet',
    links: []
  }
];

/**
 * @function Component
 * @description
 */
const Component = ( { ...props } ) => {
  const { links = defaultLinks } = props;

  /**
   * @function useEffect
   * @description Kick off this modules functions
   */
  useEffect( () => {
    new SiteNavigation();
  }, [] );

  /**
   * @function handleClick
   * @description fire off tagular events
   */
  const handleClick = ( event ) => {
    const { target } = event;
    const payload = JSON.parse( target.getAttribute( 'data-payload' ) );
    const { text, actionOutcome, position } = payload;

    const data = {
      elementType: 'BUTTON',
      location: 'GLOBAL',
      position,
      text,
      actionOutcome
    };

    trackEvent( { action: 'elementClicked', data, event } );
  };

  return <>
    <div className="l-container">

      <div className="site-header-primary">
        <div className="navigation-toggle-wrap">
          <button className="navigation-toggle" type="button" role="button">
            <span className="navigation-toggle-title screen-reader-text">Open Menu</span>
            <span className="navigation-toggle-icon">
              <span className="icon icon-bar"></span>
            </span>
          </button>{ /* <!-- .navigation-toggle--> */ }
        </div>


        <div className="site-branding">
          <h1 className="site-title">
            <Link
              href="/ps/"
              className="site-brand"
              onClick={ handleClick }
              data-payload={ stringify( {
                text: 'Frontier Logo',
                position: 'NAVIGATION',
                actionOutcome: 'INTERALLINK'
              } ) }
              rel="home">

              <Image
                priority
                src="/site-logo-rebrand.svg"
                alt="Frontier Logo"
                width={ 36 }
                height={ 36 }
                layout="responsive"
                className="site-logo"
                loading="eager"
                loader={ fastly }
              />

            </Link>
          </h1>
        </div>{ /* <!-- .site-branding --> */ }
      </div>{ /* <!-- .site-header-primary --> */ }

      <div className="navigation-collapse">
        <div id="navigation" className="navigation-area">
          <div className="navigation-area-primary">
            <nav className="navigation site-navigation" role="navigation" aria-label="Site Navigation">
              <ul className="site-menu menu">
                { links.map( ( link, index ) => (
                    <li key={ index } className="menu-item">
                        <Link
                          href={ link.href }
                          target={ link.target }
                          onClick={ handleClick }
                          data-payload={ stringify( {
                            text: link.title,
                            position: 'NAVIGATION',
                            actionOutcome: 'INTERALLINK'
                          } ) }>
                          { link.title }
                        </Link>
                    </li>
                ) ) }
              </ul>
            </nav>{ /* <!-- .site-navigation --> */ }
          </div>{ /* <!-- .navigation-area-primary --> */ }
        </div>{ /* <!-- .navigation-area --> */ }
      </div>{ /* <!-- .navigation-collapse --> */ }
    </div>
  </>;
};

Component.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape( {
      title: PropTypes.string,
      links: PropTypes.arrayOf(
        PropTypes.shape( {
          href: PropTypes.string,
          title: PropTypes.string,
          target: PropTypes.string
        } )
      )
    } )
  )
};

export default Component;
